@if (loginDisplay){
<div style="display: flex; flex-direction: column;">
  <tds-header>
    <tds-header-title>
      CAFS <span  [style]="isActingAsOtherUser() ? 'color:var(--tds-warning)' : ''">
            &nbsp;&nbsp;&nbsp; {{ (isActingAsOtherUser() ? ' Acting as: ' + loggedUser().name : '')}}
          </span>
    </tds-header-title>

    <tds-header-item *ngIf="isSysAdmin()">
      <button (click)="openSysadminDialog()">
        System Admin Tools
      </button>
    </tds-header-item>

    <tds-header-item *ngIf="!isStatUser()">
      <button (click)="getGdprForUser()">
        {{getRoleGdprMenuText()}}
      </button>
    </tds-header-item>

    <tds-header-dropdown *ngIf="isStatUser()">
      <span slot="label">Statistics</span>
      <tds-header-dropdown-list>
        <tds-header-dropdown-list-item>
          <a (click)="GetAssignmentConsultants()">Consultant assignments</a>
        </tds-header-dropdown-list-item>
        <tds-header-dropdown-list-item>
          <a (click)="GetAssignmentNoConsultants()">Assignment without consultants</a>
        </tds-header-dropdown-list-item>
        <tds-header-dropdown-list-item>
          <a (click)="openConsultanGdprDialog()">Consultant GDPR info</a>
        </tds-header-dropdown-list-item>
        <tds-header-dropdown-list-item>
          <a (click)="getGdprForUser()">{{getRoleGdprMenuText()}}</a>
        </tds-header-dropdown-list-item>
        <tds-header-dropdown-list-item>
          <a (click)="getGdprForThisUder()">{{getYourStatMenuText()}}</a>
        </tds-header-dropdown-list-item>
      </tds-header-dropdown-list>
    </tds-header-dropdown>

    <tds-header-item>
        <a title="Check the status of batch jobs"
          style="text-decoration: none;"
          (click)="openCheckBatchStatus()">
          Check batch job status
        </a>
    </tds-header-item>

    <tds-header-item *ngIf="isActingAsOtherUser()">
        <a title="Simulate another user"
          style="text-decoration: none;"
          (click)="stopActAsUser()">
          Stop act as other user
        </a>
    </tds-header-item>

    <tds-header-item>
      <a href="https://internal.scania.com/minanstallning/465.html" target="_blank" style="text-decoration: none;"
        title="Open help on Reflex in new tab or window">
        Help
      </a>
    </tds-header-item>

    <tds-header-item>
        <a title="Simulate another user"
          style="text-decoration: none;"
          (click)="showModal = true">
          Act as other user
        </a>
    </tds-header-item>

    <tds-header-dropdown slot="end" placement="end" no-dropdown-icon class="demo-hide demo-lg-show" selected>
      <img slot="icon" src="https://www.svgrepo.com/show/384676/account-avatar-profile-user-6.svg"
        alt="User menu." />
      <tds-header-dropdown-list type="sm">
        <tds-header-dropdown-list-user header="{{ reverseName(loggedUser().name) }} - {{ loggedUser().id }}"
          subheader="{{ loggedUser().role }}">
        </tds-header-dropdown-list-user>
        <tds-header-dropdown-list-item>
          <a (click)="logout()">Log Out</a>
        </tds-header-dropdown-list-item>
      </tds-header-dropdown-list>
    </tds-header-dropdown>

    <tds-header-brand-symbol slot="end">
      <a aria-label="Scania - red gryphon on blue shield" href="https://www.scania.com/" target="_blank"></a>
    </tds-header-brand-symbol>
  </tds-header>

</div>

<!-- Emulate user-->
<div *ngIf="showModal">
  <tds-modal
    header="Act as other user"
    selector="#emulateUserModal"
    show="true"
    id="emulate-user-modal"
    size="sm"
    actions-position="static"
    prevent="false" >

    <span slot="body">
      <p>Enter the email adress of the user you want to act as</p>

    <div class="tds-row ">
      <div class="tds-col-xs-12">
          <tds-text-field
            type="Text"
            size="sm"
            noMinWidth
            state="default"
            label=""
            ngDefaultControl
            label-position="inside"
            placeholder="email address"
            [(ngModel)]="emulateEmail">
          </tds-text-field>
        </div>
      </div>
    </span>

    <span slot="actions">
      <tds-button fullbleed
        style="width: 100px;"
        data-dismiss-modal
        size="sm"
        text="Start"
        [disabled]="emulateEmail.length < 5 || !emulateEmail.includes('@') || !emulateEmail.includes('.')" type="primary"
        (click)="actAsUser()" class="tds-u-mr1">
      </tds-button>
      <tds-button fullbleed
        style="width: 100px;"
        data-dismiss-modal
        size="sm"
        type="button"
        variant="secondary"
        (click)="showModal = false"
        text="Cancel">
      </tds-button>
    </span>
  </tds-modal>
</div>

<consultant-gdpr-dialog
  *ngIf="dlgType=='consultantgdprdlg'"
  [showMe]="dlgType=='consultantgdprdlg'"
  (onCloseDlg)="onCloseDlg($event)">
</consultant-gdpr-dialog>

<user-gdpr-dialog
  *ngIf="dlgType=='usergdprdlg'"
  [showMe]="dlgType=='usergdprdlg'"
  (onCloseDlg)="onCloseDlg($event)">
</user-gdpr-dialog>

<sysadmin-dialog
  *ngIf="dlgType=='sysadmindlg'"
  [showMe]="dlgType=='sysadmindlg'"
  (onCloseDlg)="onCloseDlg($event)">
</sysadmin-dialog>

<batch-job-status-dialog
  *ngIf="dlgType=='batchjobstatusdlg'"
  [showMe]="dlgType=='batchjobstatusdlg'"
  (onCloseDlg)="onCloseDlg($event)">
</batch-job-status-dialog>

<section class="col-md-12">
  <router-outlet></router-outlet>
</section>
} @else {
    <section class="landing-page">
        <img src="scania-logo.svg" alt="Scania">
        <h1>CAFS</h1>
    </section>
}
